import { render, staticRenderFns } from "./AtacModal.vue?vue&type=template&id=f394a880&scoped=true&"
import script from "./AtacModal.vue?vue&type=script&lang=js&"
export * from "./AtacModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f394a880",
  null
  
)

export default component.exports